/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-mixed-operators */
/* eslint-disable react/jsx-props-no-multi-spaces */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable consistent-return */
/* eslint-disable no-unused-vars */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-debugger */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable max-len */
/* eslint-disable react/jsx-no-script-url */
/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { motion, AnimatePresence } from 'framer-motion';
import React, {
    useState, useRef, useEffect, useCallback,
} from 'react';
import Modal from 'react-modal';
import { Link } from 'react-router-dom';
import { CamelCase, TitleCase } from '../../redux/helper/CamelCase';
import { GenerateDate, GenerateDateandTime } from '../../redux/helper/DateConverter';
import { userService } from '../../service/user.service';
import ThreeDotsLoader from '../../Components/LoadingDots';
import ModalPopup from '../../Components/ModalHandler';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
    },
};
function ListDap({
    setisPaneOpen,
    DAPList,
    filter,
    handleActivateOrDeactivate,
    OpenPopup,
    setOpenPopup,
    actvloader,
    setactvloader,
    isEditId,
    setisEditId,
    setExportClick,
    isLoaded,
    viewdapprevilegeassigned,
    updatedapprevilegeassigned,
    activatedeactivedapprevilegeassigned,
}) {
    const [searchValue, setsearchValue] = useState('');
    const [loading, setloading] = useState(false);
    const [statusLoader, setstatusLoader] = useState('');
    const [selectedUser, setselectedUser] = useState([]);
    const ref = useRef();
    const SerachUser = (val) => {
        if (searchValue === '') {
            return val;
        }
        if (val.email.toLowerCase().includes(searchValue.toLowerCase())) {
            return val;
        }
    };
    const handleStatus = (status) => {
        let res = '';
        if (status === 'Active') {
            res = 'border-[#D7F8DC] bg-[#D7F8DC] px-1 w-[82px]';
        }
        if (status === 'Inactive' || status === '0') {
            res = 'border-[#808285] bg-[#808285] text-[#FFFFFF] px-1 w-[82px]';
        }
        if (status === 'Draft') {
            res = 'border-[#FFF2DE] bg-[#FFF2DE] text-[#555259] px-1 w-[82px]';
        }
        if (status === 'Expired') {
            res = 'border-[#F8E1E4] bg-[#F8E1E4] text-[#555259] px-1 w-[82px]';
        }
        return res;
    };
    const handleImage = (status) => {
        let res = '';
        if (status === 'Active') {
            res = 'Active-icon.svg';
        }
        if (status === 'Inactive' || status === '0') {
            res = 'inactive-1.svg';
        }
        if (status === 'Draft') {
            res = 'draft.svg';
        }
        if (status === 'Expired') {
            res = 'expired-1.svg';
        }
        return res;
    };
    const handleStaustext = (status) => {
        let res = '';
        if (status === 'Active') {
            res = 'Deactivate';
        }
        if (status === 'Inactive') {
            res = 'Active';
        }
        if (status === 'Draft') {
            res = 'Activate';
        }

        return res;
    };
    const handleStatusAction = (status) => {
        let isTrue = false;
        if (status === 'Draft') {
            isTrue = true;
        }
        if (status === 'Active') {
            isTrue = true;
        }
        return isTrue;
    };

    const handleActionButtonStatus = () => {
        setisEditId('');
    };

    return (
        <AnimatePresence>
            <tbody>
                <Modal
                    style={customStyles}
                    isOpen={OpenPopup !== ''}
                    ariaHideApp={false}
                    onRequestClose={() => setOpenPopup('')}
                    onClick={() => {
                        setOpenPopup('');
                        setactvloader(false);
                    }}
                >
                    <div className="modal-dialog modal-dialog-centered relative w-auto pointer-events-none max-w-[441px]">
                        <div
                            className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current"
                        >
                            <div className="modal-header flex flex-shrink-0 items-center justify-between p-4 pt-7 rounded-t-md">
                                {OpenPopup === 'active' ? (
                                    <h5 className="text-lg font-semibold text-[#090406] text-center w-full" id="exampleModalScrollableLabel">
                                        {handleStaustext(selectedUser.policy_status)}
                                        {' '}
                                        {' '}
                                        Policy
                                    </h5>
                                ) : (
                                    <h5 className="text-lg font-semibold text-[#090406] text-center w-full" id="exampleModalScrollableLabel">
                                        Reset Password
                                    </h5>
                                )}
                                <button
                                    type="button"
                                    className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline absolute top-4 right-6"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                />
                            </div>
                            {OpenPopup === 'active' ? (
                                <div className="modal-body relative px-9 pt-2 pb-6 text-center">
                                    <p className="text-xs6 font-normal text-[#555259]">
                                        {`${selectedUser.policy_name}`}
                                        {' '}
                                        is currently
                                        {' '}
                                        {selectedUser.policy_status}
                                        . Are you sure you
                                        {' '}
                                        want to
                                        {' '}
                                        {handleStaustext(selectedUser.policy_status)}
                                        ?
                                    </p>
                                </div>
                            ) : (
                                <div className="modal-body relative px-9 pt-2 pb-6 text-center">
                                    <p className="text-xs6 font-normal text-[#555259]">
                                        Are you sure you want to reset the password for
                                        <br />
                                        {`${selectedUser.first_name} ${selectedUser.last_name}`}
                                        ?
                                    </p>
                                </div>
                            )}
                            <div className="modal-footer flex flex-shrink-0 flex-wrap justify-evenly pb-6 rounded-b-md">
                                <button
                                    onClick={() => {
                                        setOpenPopup('');
                                        setactvloader(false);
                                    }}
                                    type="button"
                                    className="border border-[#555259] bg-[#ffffff] text-base font-normal text-[#555259] py-3 px-14 rounded-lg"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className="border border-[#673593] bg-[#555259] text-base font-normal text-[#ffffff] py-3 px-14 rounded-lg"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    onClick={() => handleActivateOrDeactivate(selectedUser.policy_status, selectedUser.policy_id)}
                                >
                                    {actvloader ? <ThreeDotsLoader /> : 'Yes'}
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal>
                {DAPList?.list?.filter((val) => SerachUser(val)).map((user, i) => (

                    <>
                        <motion.tr
                            className="bg-[#FDFDFE] border-b border-[#DFEAF7] relative"
                            key={isLoaded}
                            style={{ zIndex: `${50 - i}` }}
                            animate={{ opacity: 1, x: 0 }}
                            initial={{ opacity: 0, x: -10 }}
                            exit={{ opacity: 0, x: -10 }}
                            transition={{ duration: 0.15 }}
                        >
                            <td className="text-sm font-normal text-[#090406] py-2.5 px-7 sticky left-0 bg-[#ffffffe6]">
                                <p className="">
                                    {' '}
                                    {user.policy_name}
                                </p>
                            </td>
                            <td className="text-sm font-normal text-[#090406] py-2.5 px-7">
                                {user.ship_from.DESCRIPTION || user.ship_from.CITY}
                            </td>
                            <td className="text-sm font-normal  text-[#090406] py-2.5 px-7">
                                {CamelCase(user.destination_type)}
                            </td>
                            <td className="text-sm font-normal text-[#090406]">
                                {user.dap_charges}
                            </td>
                            <td className="text-xs font-normal py-2.5 px-7 text-center">
                                <a
                                    href="#"
                                    className={`flex rounded-sm border-2 ${handleStatus(user.policy_status)} py-0.5 pr-1.5 w-fit`}
                                >
                                    <img src={`images/${handleImage(user.policy_status)}`} alt="icon" className="px-2" />
                                    {user.policy_status}
                                </a>
                            </td>
                            <td className="text-sm font-normal text-[#090406] py-2.5 px-7">
                                {GenerateDate(user.start_date)}
                            </td>
                            <td className="text-sm font-normal text-[#090406]  text-center">
                                {GenerateDate(user.end_date)}
                            </td>
                            <td className={`py-2.5 px-7 sticky right-0 bg-[#ffffffe6] ${filter || OpenPopup ? '' : 'z-50'} `}>
                                <div
                                    className="dropdown relative flex justify-center cursor-pointer"
                                    onClick={() => {
                                        if (isEditId === i) {
                                            setisEditId('');
                                        } else {
                                            setisEditId(i);
                                        }
                                    }}
                                >
                                    <button className="dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                        <img
                                            src="images/more-vertical.svg"
                                            alt="icon"
                                            className="cursor-pointer"

                                        />
                                    </button>
                                    {isEditId !== '' && (

                                        <ul
                                            className={`dropdown-menu min-w-max absolute ${isEditId === i ? 'show' : 'hidden'} z-[${i + 50}] bg-[#FFFFFF] rounded-[10px] shadow-s2`}
                                            aria-labelledby="dropdownMenuButton1"
                                            style={{ right: '60px' }}
                                        >
                                            {' '}
                                            {viewdapprevilegeassigned
                                            && (
                                                <li className="px-5 py-1.5" ref={ref}>
                                                    <Link to={`/manage-freight-policy/${user.policy_id}/view`} className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block" href="edit-admin-user.html">View</Link>
                                                </li>
                                            )}
                                            {updatedapprevilegeassigned && (user.policy_status === 'Draft' || user.policy_status === 'Active')
                                            && (
                                                <li className="px-5 py-1.5" ref={ref}>
                                                    <Link to={`/manage-freight-policy/${user.policy_id}/update`} className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block" href="edit-admin-user.html">Update</Link>
                                                </li>
                                            )}
                                            {activatedeactivedapprevilegeassigned && handleStatusAction(user.policy_status) && (
                                                <li
                                                    className="px-5 pt-1.5 pb-5"
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#deactivateUserModal"
                                                    onClick={() => {
                                                        setselectedUser(user);
                                                        setOpenPopup('active');
                                                        setisEditId('');
                                                    }}
                                                    ref={ref}
                                                >
                                                    <a
                                                        className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block"
                                                        href="javascript:void(0)"
                                                    >
                                                        { handleStaustext(user.policy_status)}

                                                    </a>
                                                </li>
                                            )}
                                        </ul>
                                    )}
                                </div>
                            </td>
                        </motion.tr>
                        <tr className="h-1" />

                    </>
                ))}
            </tbody>
        </AnimatePresence>

    );
}

export default ListDap;
